import { NodeFormValues } from "@features/builder/NodeDrawer/NodeForm"
import { Alert, Button, Grid } from "@mui/material"
import { useFormContext } from "react-hook-form"
import { useSearchParams } from "react-router"

export const MissingScenarioFileCta = () => {
  const form = useFormContext<NodeFormValues>()
  const [searchParams, setSearchParams] = useSearchParams({})

  const openMetadataDialog = () => {
    setSearchParams((params) => {
      params.set("isMetadataDialogOpen", true.toString())
      params.set("isUploadDialogOpen", true.toString())
      params.set("metadataDialogMode", "edit")

      return params
    })
  }

  return (
    <Grid container gap={1} direction="column">
      <Grid item>
        <Alert severity="warning">No scenario source file attached.</Alert>
      </Grid>
      <Grid item>
        <Button disabled={form.formState.disabled} variant="contained" onClick={openMetadataDialog}>
          Add scenario file
        </Button>
      </Grid>
    </Grid>
  )
}
